module.exports = __webpack_public_path__ + "media/images/menu/lupus-cc4285ebfa85d03b63787e69d59023f8.jpg";